export default __webpack_public_path__ + "static/bentoImg3-afcb04e35d15a7de452922dd1a3b2514.webp";